export const getBuildingInfoCardImageSrc = (image) =>
  `/static/www/buildings/${image}`;
export const getIntroCardImageSrc = (image) => `/static/intro-cards/${image}`;
export const getSvgStore = () => '/static/store.svg';
export const getSvgStoreSrcEntry = (name) => `/static/svg-store/${name}.svg`;
